import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import * as morabaaServiceWorker from "./morabaaServiceWorkerRegistration";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root")
);

if (window.location.href.indexOf("hub.morabaaapps.com") > -1) serviceWorkerRegistration.register();
else morabaaServiceWorker.register();
